import { render } from "./SprinklerInput.vue?vue&type=template&id=f228ebda&scoped=true"
import script from "./SprinklerInput.vue?vue&type=script&lang=js"
export * from "./SprinklerInput.vue?vue&type=script&lang=js"

import "./SprinklerInput.vue?vue&type=style&index=0&id=f228ebda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f228ebda"]])

export default __exports__